import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Highlights() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              The <span style={{ color: "#2F55C4" }}>Highlights</span>
            </h2>
            <p>
              Our development team made it possible for users to automatically
              connect with each other on LinkedIn, one of the most widely used
              networking tools of the 21st century.
            </p>
            <p>
              We included QR code recognition as a key feature of the app, which
              makes retrieving data fast and easy. We have also added an OCR
              scanner in the app because recording information correctly becomes
              an automatic process that helps users save time and be more
              efficient.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/smartID/tekre_img_03.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1494}
              height={868}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
